import * as React from 'react';
import styled from 'styled-components';

import DocsHelper from 'util/DocsHelper';
import { PageHeader } from 'components/common';
import { Col } from 'components/bootstrap';
import AlertsEntityTable from 'security-app/components/SecurityEvents/Alerts/AlertsEntityTable';

const StyledIndexRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  gap: 0.5rem;
`;

const StyledIndexWrapper = styled.div`
  flex: 1;
  border: 1px solid ${(props: any) => props.theme.colors.variant.lighter.default};
  border-radius: 5px;
  padding: 5px 10px;
  background-color: ${(props: any) => props.theme.colors.global.contentBackground};
`;

function SecurityUI() {
  return (
    <>
      <Col md={12}>
        <PageHeader
          title="Alerts"
          documentationLink={{
            title: 'Security Events Documentation',
            path: DocsHelper.PAGES.SECURITY_EVENTS,
          }}>
          <span>
            Define Events through different conditions. Add Notifications to Alerts that require your attention.
          </span>
        </PageHeader>
      </Col>
      <StyledIndexRow>
        <StyledIndexWrapper>
          <Col md={12}>
            <AlertsEntityTable />
          </Col>
        </StyledIndexWrapper>
      </StyledIndexRow>
    </>
  );
}

export default SecurityUI;
